var React = require('react');

function Globe (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M48 12C63.464 12 76 24.536 76 40C76 55.464 63.464 68 48 68C32.536 68 20 55.464 20 40C20 24.536 32.536 12 48 12ZM52 79.8026V84.0001H60V92.0001H36V84.0001H44V79.8019C34.8527 78.8913 26.3891 74.8771 19.8915 68.459L25.5134 62.7674C31.4664 68.6475 39.4632 72.0001 48 72.0001C65.6731 72.0001 80 57.6732 80 40.0001C80 31.5989 76.7539 23.719 71.0392 17.792L76.7982 12.2392C83.9365 19.6427 88 29.5067 88 40.0001C88 60.7415 72.2133 77.7957 52 79.8026ZM28 40C28 28.9543 36.9543 20 48 20C59.0457 20 68 28.9543 68 40C68 51.0457 59.0457 60 48 60C36.9543 60 28 51.0457 28 40Z","fill":"#056839"}));
}

Globe.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Globe;

Globe.default = Globe;
